<template lang="pug">
div
  el-row
    el-row.marginTop
      el-col(:span="12")
        app-display(
          label="Tipo de cadastro:",
          :content="tipo",
        )
      el-col(:span="12")
        app-display(
          label="Data de cadastro:",
          :content="this.dataCadastro",
        )
      el-col(:span="12",v-if="dataRetificacao")
        app-display(
          label="Data de retificação:",
          :content="this.dataRetificacao",
        )
  el-row
    app-divider(label="Qualificação")
    el-col(:span="24")
      .margem.marginTop
        app-display(
          v-if="qualificacao.area"
          :label="labelQualificacao.area",
          :content="!isMaranhao ? qualificacao.area : qualificacaoAreaFormatada + ' hectare(s)'"
          :class = "compararQualificacaoOneroso && compararQualificacaoOneroso.mudouArea ? 'text': '' "
        )
        app-display(
          v-if="qualificacao && qualificacao.municipio && !isMaranhao"
          label="Município:",
          :content="qualificacao.municipio.nome || '-'"
          :class = "compararQualificacaoOneroso && compararQualificacaoOneroso.mudouMunicipio.mudouNome ? 'text': '' "
        )
        app-display(
          v-if="endereco && endereco.municipio && isMaranhao"
          label="Município:",
          :content="endereco.municipio.nome || '-'"
        )
        app-display(
          label="Qual a renda familiar?",
          :content="renda",
          :class = "compararQualificacaoOneroso && compararQualificacaoOneroso.mudouRenda ? 'text': '' "
        )
        app-display(
          :label="labelQualificacao.cargoPublico",
          :content="qualificacao.cargoPublico ? 'Sim' : 'Não'"
          :class = "compararQualificacaoOneroso && compararQualificacaoOneroso.mudouCargoPublico ? 'text': '' "
        )
        app-display(
          :label="labelQualificacao.possuiImovelRuralTitulado",
          :content="qualificacao.possuiImovelRuralTitulado ? 'Sim' : 'Não'"
          :class = "compararQualificacaoOneroso && compararQualificacaoOneroso.mudouPossuiImovelRuralTitulado ? 'text': '' "
        )
        app-display(
          v-if="qualificacao.possuiImovelRuralTitulado"
          :label="labelQualificacao.tamanhoImovelTitulado",
          :content="formatterDecimal(qualificacao.tamanhoImovelTitulado) + ' hectare(s)'",
        )
        app-display(
          v-if="qualificacao.municipio"
          :label="isMunicipioIlha(qualificacao) ? labelQualificacao.ocupaImovelIlha : labelQualificacao.ocupaImovel",
          :content="qualificacao.ocupaImovel ? 'Sim' : 'Não'"
          :class = "compararQualificacaoOneroso && compararQualificacaoOneroso.mudouOcupaImovel ? 'text': '' "
        )
        app-display(
          :label="labelQualificacao.exploracaoAgricola",
          :content="qualificacao.exploracaoAgricola ? 'Sim' : 'Não'",
          :class = "compararQualificacaoOneroso && compararQualificacaoOneroso.mudouExploracaoAgricola ? 'text': '' "
        )
        span.pessoas Lista de pessoas que acompanham o processo
          div.viewPersonInfo(v-for="(pessoa, index) in pessoas" :key="index")
            span.text {{pessoa.nomeRazaoSocial}}
            span.text {{pessoa.documento ? pessoa.documento.nome : ''}}
            el-tooltip(
              effect='dark',
              content='Baixar arquivo',
              placement="top"
            )
              button.buttonDocument(
                v-if="pessoa.documento"
                @click="getDownload(pessoa.documento)"
              )
                font-awesome-icon(icon="download", size="lg")

</template>

<script>
import FileSaver from 'file-saver'
import axios from '@/utils/api'
import AppDisplay from '../AppDisplay'
import AppDivider from '@/components/AppDivider'
import utils from '@/utils/utils'
const { labelVisualizacaoProcesso, rendaEnum } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {

  components: {
    AppDisplay,
    AppDivider
  },

  props: {
    qualificacao: {
      type: Object,
      required: true
    },
    endereco: {
      type: Object,
      required: false
    },
    tipo: {
      type: String,
      required: true
    },
    dataCadastro: {
      type: String,
      required: true
    },
    pessoas: {
      type: Array,
      required: true
    },
    compararQualificacaoOneroso: {
      type: Object,
      required: false
    },
    dataRetificacao: {
      type: String,
      default: null
    }
  },

  computed: {
    renda () {
      return rendaEnum[this.qualificacao.renda]
    },
    tipoInformacaoDesejada () {
      if (this.informacaoDesejada.descricaoOutro) {
        return 'Outros - ' + this.informacaoDesejada.descricaoOutro
      }
      if (this.informacaoDesejada.tipoInformacao != null && this.informacaoDesejada.tipoInformacao.descricao === 'Outro') {
        return this.informacaoDesejada.outro
      }
      if (this.informacaoDesejada.tipoInformacao != null && this.informacaoDesejada.tipoInformacao.descricao) {
        return this.informacaoDesejada.tipoInformacao.descricao
      }
      return '-'
    },
    getJustificativa () {
      return this.informacaoDesejada.justificativa !== null ? this.informacaoDesejada.justificativa : '-'
    },
    isMaranhao () {
      return process.env.ESTADO === 'ma'
    },
    qualificacaoAreaFormatada () {
      return utils.numberToStringFourDigits(this.qualificacao.area)
    }
  },

  data () {
    return {
      labelQualificacao: labelVisualizacaoProcesso.etapaQualificacao
    }
  },

  methods: {
    isMunicipioIlha (qualificacao) {
      return qualificacao?.municipio?.id ? utils.municipiosIlha(qualificacao?.municipio?.id) : false
    },

    async getDownload (documento) {
      const file = await axios({
        method: 'POST',
        url: `documento/file`,
        data: documento,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, documento.nome)
    },
    formatterDecimal (value) {
      return utils.format(value, { prefix: '', suffix: '', thousands: '.', decimal: ',', precision: 4 })
    }

  }
}
</script>

<style lang="scss" scoped>
  .margem {
    margin-left: 6px;
  }
  .marginTop {
    padding-top: 15px;
  }
  .pessoas{
    font-weight: bold;
    font-size: 16px;
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
  }
  >>> .text .text{
    color: #ff0000 !important;
  }
  .viewPersonInfo{
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
    margin-top: 10px;
  }
  .text{
    font-size: 14px;
    width: 40%;
  }
  .buttonDocument{
    border: none;
    background: none;
    padding: 0;
    width: 20%;
  }
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/InformacoesQualificacaoOneroso.vue